import { Box, Button } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { usePage } from 'contexts/Page/Page';
import { useSounds } from 'contexts/Sounds/Sounds';
import { useMemo } from 'react';
import { MaterialSymbol } from 'react-material-symbols';
import Info from '../Info/Info';

const disabledRounds = ['init', 'hole', 'end'];

export default function RewindButton() {
    const game = useGame();
    const page = usePage();
    const sounds = useSounds();

    const { disableRewindButton, highlightRewindButton, rewindButtonLesson } = game.lessonProps;

    const disabled = useMemo(() => {
        return disableRewindButton || (!rewindButtonLesson && disabledRounds.includes(game.round));
    }, [disableRewindButton, game.round, rewindButtonLesson]);

    function handleClick() {
        if (!game.loading && game.ready) {
            sounds.play('rewind');
            game.rewind(!rewindButtonLesson);

            if (rewindButtonLesson) {
                page.show(rewindButtonLesson);
            }
        }
    }

    return (
        <Box position="relative">
            <Button
                color={highlightRewindButton ? 'primary' : 'inherit'}
                className="info"
                disabled={disabled}
                startIcon={<MaterialSymbol aria-hidden icon="history" size={23} />}
                tabIndex={18}
                variant="text"
                onClick={handleClick}
            >
                Rewind
            </Button>
            <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="center"
                paddingX={1}
                position="absolute"
                right={0}
                top={0}
                zIndex={1}
            >
                <Info name="rewind" tabIndex={19} />
            </Box>
        </Box>
    );
}
